import { graphql } from "../gql";

const getHeadToHeadBetSuccessQuery = graphql(`
  query GetHeadToHeadBetSuccess($input: OddsMarketTypesInput!) {
    event(input: $input) {
      playerPropOddsResult {
        anytimeTDs {
          gameStat
          seasonStat
          statUnit
          line
          odds
          success
          player {
            firstName
            lastName
            name
            numberfireId
            position
          }
          team {
            shortName
            teamJerseySVG
          }
        }
        overPassingYards {
          gameStat
          seasonStat
          statUnit
          line
          odds
          success
          player {
            firstName
            lastName
            name
            numberfireId
            position
          }
          team {
            shortName
            teamJerseySVG
          }
        }
        overRushingYards {
          gameStat
          seasonStat
          statUnit
          line
          odds
          success
          player {
            firstName
            lastName
            name
            numberfireId
            position
          }
          team {
            shortName
            teamJerseySVG
          }
        }
        overReceivingYards {
          gameStat
          seasonStat
          statUnit
          line
          odds
          success
          player {
            firstName
            lastName
            name
            numberfireId
            position
          }
          team {
            shortName
            teamJerseySVG
          }
        }
      }
    }
  }
`);

export default getHeadToHeadBetSuccessQuery;
